import { createApp } from 'vue';
import OpusToWavConverter from '@/Components/OpusToWavConverter.vue';
import '@styles/app.css';

createApp(OpusToWavConverter).mount('#opus-to-wav-converter');
